import React, { useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import CustomTable from "./table";

const dateFormat = "DD-MM-YYYY";
const FilterTable = ({
  placeHolder,
  fileName,
  columns,
  data,
  options,
  className,
  loading,
  tableDateFormat,
  enableGoogleAnalytics,
  bottomActions,
  onSelectAllChange,
  onFilterChange
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [localSelectedFilters, setLocalSelectedFilters] = useState([]);
  const dataWithIndex = data.map((element, myTableIndex) => ({ ...element, myTableIndex }));
  const { remoteSelectedFilters, setRemoteSelectedFilters } = options;

  const selectedFilters = remoteSelectedFilters || localSelectedFilters;
  const setSelectedFilters = setRemoteSelectedFilters || setLocalSelectedFilters;

  const filteredRow = dataWithIndex
    .filter(x => {
      let isValid = true;
      selectedFilters.forEach(el => {
        if (el.type && el.type === "date") {
          isValid =
            isValid &&
            moment(x[el.key], tableDateFormat).isSameOrAfter(
              moment(el.value.startDate, dateFormat)
            ) &&
            moment(x[el.key], tableDateFormat).isSameOrBefore(moment(el.value.endDate, dateFormat));
        } else {
          isValid = el.value === "all" || (isValid && x[el.key] === el.value);
        }
      });
      return isValid;
    })
    .filter(x => {
      const result =
        !searchQuery ||
        Object.values(x).some(value => {
          const result2 = (value + "".toUpperCase()).includes(searchQuery.toUpperCase());
          return result2;
        });
      return result;
    });
  const downloadCSV = () => {
    let csvContent = "";
    filteredRow.forEach(row => {
      Object.values(row).forEach(e => {
        csvContent += `${e},`;
      });
      csvContent += "\n";
    });
    const hiddenElement = document.createElement("a");
    hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csvContent)}`;
    hiddenElement.target = "_blank";
    hiddenElement.download = fileName;
    hiddenElement.click();
  };
  return (
    <CustomTable
      placeHolder={placeHolder}
      onGenerateCSVClick={() => downloadCSV()}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      setSelectedFilters={value => {
        setSelectedFilters(value);
        onFilterChange(value);
      }}
      selectedFilters={selectedFilters}
      columns={columns}
      data={filteredRow}
      options={options}
      className={className}
      loading={loading}
      enableGoogleAnalytics={enableGoogleAnalytics}
      bottomActions={bottomActions}
      onSelectAllChange={newValue => onSelectAllChange(newValue, filteredRow)}
    />
  );
};

// To make proptype recursive
const columnShape = {
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  options: PropTypes.shape({
    show: PropTypes.bool, // default to true
    sort: PropTypes.bool, // default to true
    filter: PropTypes.bool, // default to true
    visible: PropTypes.bool, // default to true
    weigth: PropTypes.number, // default 1, order filter asc
    cellRenderer: PropTypes.func,
    headerRenderer: PropTypes.func,
    expandedColumn: PropTypes.bool,
    emptyFilteredElement: PropTypes.node,
    cellClass: PropTypes.string,
    headerClass: PropTypes.string
  })
};
columnShape.columns = PropTypes.arrayOf(PropTypes.shape(columnShape));

FilterTable.propTypes = {
  fileName: PropTypes.string,
  tableDateFormat: PropTypes.string,
  className: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape(columnShape)).isRequired,
  // Unknown shape
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array,
  loading: PropTypes.bool,
  placeHolder: PropTypes.string,
  enableGoogleAnalytics: PropTypes.bool,
  // TODO
  options: PropTypes.shape({
    pagination: PropTypes.bool, // default to true
    filter: PropTypes.bool, // default to true
    weith: PropTypes.number, // default to 1
    rowExpansion: PropTypes.bool, // default to true
    rowsPerPage: PropTypes.arrayOf(PropTypes.number),
    hasExpansion: PropTypes.bool, // default to true
    expandedRows: PropTypes.arrayOf(PropTypes.number),
    selectableRows: PropTypes.bool, // default to false
    extraToolbarOptions: PropTypes.node,
    emptyElement: PropTypes.node,
    toolbar: PropTypes.bool,
    remoteSelectedFilters: PropTypes.array,
    setRemoteSelectedFilters: PropTypes.func,
    remotePageIndex: PropTypes.number,
    setRemotePageIndex: PropTypes.func,
    remoteSort: PropTypes.string,
    setRemoteSort: PropTypes.func,
    remoteDesc: PropTypes.bool,
    setRemoteDesc: PropTypes.func,
    type: PropTypes.oneOf(["string", "boolean", "date"]),
    filterRenderer: PropTypes.func,
    removeDownloadAction: PropTypes.bool
  }),
  bottomActions: PropTypes.node,
  onSelectAllChange: PropTypes.func,
  onFilterChange: PropTypes.func
};

FilterTable.defaultProps = {
  fileName: "table.csv",
  tableDateFormat: "YYYY-MM-DD",
  className: "",
  options: {
    type: "string",
    filterRenderer: value => value
  },
  data: [],
  loading: false,
  placeHolder: "Buscar...",
  enableGoogleAnalytics: false,
  bottomActions: null,
  onSelectAllChange: () => {},
  onFilterChange: () => {}
};

export default FilterTable;
